
import React from "react";
import { Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

interface MobileNavProps {
  closeMobileMenu: () => void;
}

const MobileNav = ({ closeMobileMenu }: MobileNavProps) => {
  const { user, signOut } = useAuth();
  
  return (
    <div className="md:hidden bg-[#05111e] border-t border-white/10 text-white shadow-xl mt-2 rounded-b-lg">
      <div className="container mx-auto px-4 py-2">
        <nav className="flex flex-col space-y-3 pb-4">
          <Link 
            to="/" 
            className="text-white hover:text-[#D4AF37] transition-colors py-2 font-medium"
            onClick={closeMobileMenu}
          >
            Home
          </Link>
          <Link 
            to="/pricing" 
            className="text-white/90 hover:text-[#D4AF37] transition-colors py-2 font-medium"
            onClick={closeMobileMenu}
          >
            Preços
          </Link>
          <Link 
            to="/about" 
            className="text-white/90 hover:text-[#D4AF37] transition-colors py-2 font-medium"
            onClick={closeMobileMenu}
          >
            Sobre
          </Link>
          <Link 
            to="/features" 
            className="text-white/90 hover:text-[#D4AF37] transition-colors py-2 font-medium"
            onClick={closeMobileMenu}
          >
            Funcionalidades
          </Link>
          
          <div className="border-t border-white/10 pt-3 mt-2">
            {user ? (
              <div className="flex flex-col space-y-2">
                <Button 
                  asChild 
                  variant="ghost"
                  className="text-white hover:text-[#D4AF37] hover:bg-white/10 justify-start"
                  onClick={closeMobileMenu}
                >
                  <Link to="/dashboard">
                    Dashboard
                  </Link>
                </Button>
                <Button 
                  onClick={() => {
                    signOut();
                    closeMobileMenu();
                  }} 
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/10 w-full bg-transparent"
                >
                  Sair
                </Button>
              </div>
            ) : (
              <div className="flex flex-col space-y-2">
                <Button 
                  asChild 
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/10 justify-start bg-transparent"
                  onClick={closeMobileMenu}
                >
                  <Link to="/auth/login" className="flex items-center">
                    <LogIn className="mr-2 h-4 w-4" />
                    Login
                  </Link>
                </Button>
                <Button 
                  asChild
                  className="bg-[#D4AF37] hover:bg-[#BFA02A] text-[#072A45] font-semibold transition-colors w-full border-0"
                  onClick={closeMobileMenu}
                >
                  <Link to="/auth/register" className="flex items-center justify-center">
                    <UserPlus className="mr-2 h-4 w-4" />
                    Registrar
                  </Link>
                </Button>
              </div>
            )}
          </div>
        </nav>

      </div>
    </div>
  );
};

export default MobileNav;
